"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipInviteFactory = exports.membershipInviteMembershipDefinitionOrganizationFactory = exports.membershipInviteAffiliationOrganizationFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
const membership_definition_factory_1 = require("./membership-definition.factory");
const membership_factory_1 = require("./membership.factory");
exports.membershipInviteAffiliationOrganizationFactory = Factory.Sync.makeFactory({
    id: mocks_1.orgClub.id,
    name: mocks_1.orgClub.name,
    timezone: 'America/Chicago',
    logo: {
        url: 'http://logo.png',
        is_default: false
    }
});
exports.membershipInviteMembershipDefinitionOrganizationFactory = Factory.Sync.makeFactory({
    id: mocks_1.orgNgb.id,
    name: mocks_1.orgNgb.name,
    timezone: 'America/Chicago',
    logo: {
        url: 'http://logo.png',
        is_default: false
    }
});
exports.membershipInviteFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    membership_id: Factory.each(i => uuid_1.v4()),
    membership_ids: Factory.each(i => [uuid_1.v4()]),
    membership_definition_id: Factory.each(i => uuid_1.v4()),
    persona_id: 1,
    affiliation_organization_id: mocks_1.orgClub.id,
    status: 'pending',
    created_by_user_id: 1,
    custom_message: 'test',
    expires_at: mocks_1.dates.date2100,
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    accepted_at: mocks_1.dates.date2000,
    sent_by_org_id: mocks_1.orgNgb.id,
    sent_by_persona_id: 1,
    email_address: 'test@example.com',
    last_sent_at: mocks_1.dates.date2000,
    dismissed: false,
    membership_definition: membership_definition_factory_1.membershipDefinitionFactory.build(),
    clare_sale_group: 'test',
    persona: membership_factory_1.membershipPersonaFactory.build(),
    affiliation_organization: exports.membershipInviteAffiliationOrganizationFactory.build(),
    membership_definition_organization: exports.membershipInviteMembershipDefinitionOrganizationFactory.build(),
    sent_at_formatted: mocks_1.dates.date2000,
});
